// Centralized service client factory to prevent multiple Supabase instances
import { createClient } from '@supabase/supabase-js'

// Cache for service client to ensure singleton pattern
let _serviceClient: any = null

// Get environment-aware configuration (centralized version)
const getServiceEnvironmentConfig = () => {
  // Check environment variables for service-side operations
  if (typeof process !== 'undefined' && process.env) {
    const supabaseUrl = process.env.SUPABASE_URL || process.env.VITE_SUPABASE_URL
    let serviceKey = process.env.SUPABASE_SERVICE_KEY
    
    // Environment-specific service keys
    if (!serviceKey && supabaseUrl) {
      // Local development
      if (supabaseUrl === 'http://127.0.0.1:54321') {
        serviceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImV4cCI6MTk4MzgxMjk5Nn0.EGIM96RAZx35lJzdJsyH-qQwv8Hdp7fsn3W0YpN81IU'
      }
      // Staging environment
      else if (supabaseUrl === 'https://rntynqplrfyidfwnifip.supabase.co') {
        serviceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJudHlucXBscmZ5aWRmd25pZmlwIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc2MTA1NTU3NywiZXhwIjoyMDc2NjMxNTc3fQ.ijQ2sVBK4nOL3IiHhvrwmLuGJBxsmqzXwgQSrUe6jTs'
      }
      // Production environment
      else if (supabaseUrl === 'https://killgsyghirjkdsjnfta.supabase.co') {
        serviceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtpbGxnc3lnaGlyamtkc2puZnRhIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc2MTA2MjA2NCwiZXhwIjoyMDc2NjM4MDY0fQ.Nj1_F_MmG9brvw2YdLZPEbo8qXcxjNgYhB8X-ENndJs'
      }
    }

    if (!supabaseUrl || !serviceKey) {
      console.error('❌ Service client: Missing Supabase URL or service key')
      console.error('  SUPABASE_URL:', supabaseUrl ? 'SET' : 'MISSING')
      console.error('  Service key:', serviceKey ? 'SET' : 'MISSING')
    }

    return { supabaseUrl, serviceKey }
  }

  // Fallback for browser environments (shouldn't happen for service clients)
  console.error('❌ Service client accessed in browser environment')
  return { supabaseUrl: null, serviceKey: null }
}

// Create singleton service client for API endpoints
export const createServiceClient = () => {
  if (_serviceClient) {
    console.log('✅ Reusing existing service client singleton')
    return _serviceClient
  }

  const { supabaseUrl, serviceKey } = getServiceEnvironmentConfig()

  if (!supabaseUrl || !serviceKey) {
    throw new Error('Service client configuration missing - check environment variables')
  }

  console.log('🔧 Creating service client singleton:', { 
    url: supabaseUrl, 
    hasServiceKey: !!serviceKey 
  })

  _serviceClient = createClient(supabaseUrl, serviceKey, {
    auth: {
      autoRefreshToken: false, // Service clients don't need token refresh
      persistSession: false,   // Service clients don't persist sessions
      detectSessionInUrl: false
    },
    realtime: {
      params: {
        eventsPerSecond: 2 // Reduce realtime load for service clients
      }
    }
  })

  console.log('✅ Service client singleton created successfully')
  return _serviceClient
}

// Reset function for testing purposes
export const resetServiceClient = () => {
  console.log('🔄 Resetting service client singleton')
  _serviceClient = null
}